import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { GridItem, TextField } from 'seagull';
import { templateNameValidation, templateNameValidator } from '~/business-logic/validators';
import { useOnMount } from '~/hooks/useOnMount';
export function TemplateName(param) {
    let { templateTitle, showWarning, setTemplateTitle, setTemplateTitleValid, label, disabled, testId, fullWidth } = param;
    const { control, formState, watch, trigger } = useForm({
        mode: 'all',
        defaultValues: {
            templateTitle
        }
    });
    useEffect(()=>{
        return watch((data)=>{
            var _data_templateTitle;
            setTemplateTitle((_data_templateTitle = data.templateTitle) !== null && _data_templateTitle !== void 0 ? _data_templateTitle : '');
        }).unsubscribe;
    }, [
        setTemplateTitle,
        watch
    ]);
    useEffect(()=>{
        setTemplateTitleValid(formState.isValid);
    }, [
        formState,
        setTemplateTitleValid
    ]);
    useEffect(()=>{
        if (showWarning) trigger('templateTitle');
    }, [
        showWarning,
        trigger
    ]);
    useOnMount(()=>{
        trigger('templateTitle');
    });
    const field = /*#__PURE__*/ _jsx(Controller, {
        control: control,
        name: "templateTitle",
        rules: templateNameValidation,
        render: (param)=>{
            let { field, fieldState: { isTouched, error } } = param;
            return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                mobile: {
                    renderAsCard: true
                }
            }, field, templateNameValidation.dataAttr), {
                label: label,
                disabled: disabled,
                testId: testId,
                placeholder: "The template name will help you identify this template",
                error: (showWarning || isTouched) && !!error,
                helperText: (showWarning || isTouched) && (error === null || error === void 0 ? void 0 : error.message),
                validateInBottomSheet: (value)=>{
                    const result = templateNameValidator(value);
                    return {
                        error: result !== true,
                        helperText: typeof result === 'string' ? result : undefined
                    };
                }
            }));
        }
    });
    return fullWidth ? /*#__PURE__*/ _jsx(GridItem, {
        span: 12,
        children: field
    }) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(GridItem, {
                span: 9,
                children: field
            }),
            /*#__PURE__*/ _jsx(GridItem, {
                span: 3
            })
        ]
    });
}
